export enum OrderEvent {
  downloadReady = 'downloadReady',
  directDownload = 'directDownload',
}
